import React from "react";
import Logo from "@/app/components/icons/Logo";

export default function IntroHeader() {
	return (
		<header className="sticky top-4 z-30 w-full">
			<div className="flex h-12 w-full items-center justify-between overflow-clip rounded-[14px] border border-transparent p-1">
				<div className="flex w-full items-center justify-between overflow-clip rounded-[10px] px-3 py-2">
					<a
						href="https://outpacestudios.com"
						className="h-3 w-8"
						aria-label="Outpace Studios home"
						target="_blank"
						rel="noopener noreferrer"
					>
						<Logo className="h-full w-full" />
					</a>
					<p className="font-display text-base font-semibold leading-6 tracking-[-0.01em] text-[#ff4f1a]">
						Outpace Studios™
					</p>
				</div>
			</div>
		</header>
	);
}
